import styled from '@emotion/styled';
import { Text } from '@naf/text';
import { breakpoints, spacing } from '@naf/theme';
import { GridCol } from '@naf/grid';
import { nafColor } from '@nafcore/theme';

export const Heading = styled(Text)`
  margin-bottom: ${spacing.space24};
`;

export const BodyWrapper = styled.div`
  margin-bottom: ${spacing.space32};

  h3 {
    margin-top: 0;
  }
`;

export const ErrorMessage = styled(Text)`
  color: ${nafColor.information.errorDark};
  margin-top: ${spacing.space16};
  scroll-margin-top: ${spacing.space120};
`;

export const ResponsiveCol = styled(GridCol)`
  @media (max-width: ${breakpoints.m}) {
    display: none;
  }
`;
